import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '../../assets/images/message/message.png'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "title" }, "通知", -1)
const _hoisted_3 = { class: "context" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_5 = { class: "dialog-footer" }

import message from "@/api/message";
import { ref, watch } from "vue";
import { useRouter } from "vue-router";
import {DefaultWebServiceFactory} from "@/services/webapi/DefaultWebServiceFactory";

export default /*#__PURE__*/_defineComponent({
  __name: 'MessageDialog',
  props: {
  item: {
    type: [Object],
  },
},
  setup(__props) {

const props = __props;


watch(props, () => {
  content.value = props.item.content;
  requestId.value = props.item.requestId;
  dialogFormVisible.value = true;
});
const close = () => (dialogFormVisible.value = false);
const dialogFormVisible = ref<boolean>(false);
const router = useRouter();
const content = ref<string>("");
const requestId = ref();
const toTalk = () => {
  message.MessageToTalk(requestId.value, props.item.orderId).then((t) => {
    console.log(t);
    message.setRead(props.item.orderId);
    router.push(t);
  });
};
// 接受请求
// const toWatch = () => {
//   DefaultWebServiceFactory.getInstance()
//     .getWebMessageService()
//     .setReadMessage(props.item.orderId);
//   router.push({
//     path: "/layout/home",
//     query: {
//       index: 2,
//     },
//   });
// };

return (_ctx: any,_cache: any) => {
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    class: "messageDialog",
    modelValue: dialogFormVisible.value,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((dialogFormVisible).value = $event)),
    width: "30%",
    modal: false,
    "show-close": false,
    onClose: close
  }, {
    header: _withCtx(() => [
      _hoisted_1,
      _hoisted_2
    ]),
    footer: _withCtx(() => [
      _createElementVNode("span", _hoisted_5, [
        _createVNode(_component_el_button, { onClick: toTalk }, {
          default: _withCtx(() => [
            _createTextVNode("进入会话")
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (dialogFormVisible.value = false))
        }, {
          default: _withCtx(() => [
            _createTextVNode("稍后处理")
          ]),
          _: 1
        })
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_el_form, null, {
        default: _withCtx(() => [
          _createElementVNode("p", _hoisted_3, _toDisplayString(content.value), 1),
          _hoisted_4
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})